module.exports = __webpack_public_path__ + "17cc8bde1420bd13ee00463ed346e682.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/sushi.png
// module id = 2438
// module chunks = 0